module.exports = __webpack_public_path__ + "img/winter_sports_travel_insurance.9a3326fa.jpg";